import {useState} from 'react';
import {compose} from '../../lib/compose';
import {Button, Row, Col, Form} from 'react-bootstrap';
import withAlerts from '../../lib/withAlerts';
import {usePolicyMutations} from './policyMutations';
import {usePortalContext} from '../../lib/context/portalContext';
import {useForm, FormProvider} from "react-hook-form";
import {ErrorMessage} from '@hookform/error-message';
import { gql } from "@apollo/client";
import { useLazyQuery } from "@apollo/client/react";
import PolicyForm from './policyForm';

const CreatePolicy = ({minPolicy, alerts = {}, clicked = ''}) => {
  const {togglePortal} = usePortalContext();
  const [thresholdError, setThresholdError] = useState(null);
  const [existsError, setExistsError] = useState(null);
  const [defaultExistsError, setDefaultExistsError] = useState(null);
  const [minimumError, setMinimumError] = useState(null);
  const {add} = usePolicyMutations();
  const [getPolicy] = useLazyQuery(GET_POLICY);
  const {error, success} = alerts;

  const methods = useForm({
    mode: 'all'
  });

  const {setFocus, getValues, formState: {errors}} = methods || {};

  const onSubmit = async (formData) => {    
    //throw an error if the threshold isnt set
    if( formData.has_battery_warning && (formData.battery_warning_threshold === 0 || formData.battery_warning_threshold === undefined)) {
      setThresholdError('Battery Level Sufficient percentage is required.');
      return;
    }
    
    const variables = {
      variables: {
        filters: {
          field: "name",
          value: `${formData?.name}`,
        }
      }
    };

    //lazyQuery to inline validate against existing policies
    let policyNameInUse;
    const checkExistingPolicy = await getPolicy(variables);
    
    if(checkExistingPolicy?.data?.Policies?.result?.length > 0) {
      const checkPolicies = checkExistingPolicy?.data?.Policies?.result || [];

      policyNameInUse = checkPolicies.find(p => p.name === formData?.name);

      if(policyNameInUse) {
        setExistsError('Policy Name already exists.');
        setFocus('name');
        return;
      }
    }

    const policyShape = {...formData, is_phone_protected: true};
    if (!policyShape['is_default_visitor']) {
        delete policyShape['is_default_visitor'];
    }

    //New Policy to create
    const createPolicy = await add({variables: {policy: policyShape}});
    console.log(createPolicy);
    if(createPolicy?.errors) {
      
      error({msg: `There was an error creating the new policy. Please try again.`});
      
    } else {
      success({msg: `Policy created.`});
      togglePortal();
    } 
  }

  return (
    <FormProvider {...methods}>
      <Form onSubmit={methods.handleSubmit(onSubmit)}>
        <PolicyForm
          minPolicy={minPolicy}
          existsError={existsError}
          setExistsError={setExistsError}
          thresholdError={thresholdError}
          setThresholdError={setThresholdError}
          defaultExistsError={defaultExistsError}
          setDefaultExistsError={setDefaultExistsError}
          setMinimumError={setMinimumError}
          clicked={clicked} //tells policy form the origin
        />
        <Row>
          <Col>
            <div className="d-grid gap-2">
              <Button
                className="mb-3"
                type="submit"
                disabled={minimumError || existsError || defaultExistsError || thresholdError || methods?.errors?.name}
                >Save Policy</Button>

              <div className="mb-3">
                <ErrorMessage
                  errors={methods?.errors}
                  name="name"
                  render={({ message }) => <strong className="mb-3 d-block">{message}</strong>}
                />
                     
                {minimumError && <strong className="mb-3 d-block">Invalid Policy. Minimum requirements unmet.<br/></strong>}
                {errors?.policy_action && <strong className="mb-3 d-block">MDM Actions must be selected when MDM feature is enabled.<br/></strong>}
                {existsError && <strong className="mb-3 d-block">{existsError}<br/></strong>}
                {defaultExistsError && <strong className="mb-3 d-block">{defaultExistsError}<br/></strong>}
                {thresholdError && <strong className="mb-3 d-block">{thresholdError}<br/></strong>}
              </div>
            </div>
          </Col>
        </Row>
      </Form>
    </FormProvider>
    
  )
}

const GET_POLICY = gql`
  query Policies ($filters: GenericFilters) {
    Policies (filters: $filters) {
      result {
        id
        name
      }
    }
  }
`;


export default compose(
  withAlerts,
)(CreatePolicy);
